import { ArgsType } from '@nestjs/graphql'
import { BaseAddPictureDto } from '../base/baseAddPicture.dto'

// fileName is already declared on BaseAddPictureDto.
@ArgsType()
export class ArcAddFileDto extends BaseAddPictureDto {
}
